import axios from "axios";
import { Edge } from "@xyflow/react";

import { IItem } from "../../../pages/SimuladorInteligente/interfaces";
import { CustomNode } from "../../../pages/ConfiguracaoSimulador/interfaces";

import { urlHttpGov } from "../../urls";
import { getToken } from "../../LStorage/token";

class FluxoService {
  private readonly baseURL = `${urlHttpGov}/simulador-inteligente/fluxo`;

  async create({
    nodes,
    edges,
    itens,
  }: {
    nodes: CustomNode[],
    edges: Edge[],
    itens: IItem[],
  }): Promise<IItem[]> {
    const { data } = await axios.post(this.baseURL, {
      nodes,
      edges,
    }, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data;
  }

  async getEdgesAndNodes(signal: AbortSignal): Promise<{
    _id: string,
    edges: Edge[],
    nodes: CustomNode[],
  }> {
    const { data } = await axios.get(`${this.baseURL}/edges-nodes`, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      },
      signal
    });

    return data;
  }

  async getItems(signal: AbortSignal): Promise<IItem[]> {
    const { data } = await axios.get(`${this.baseURL}/itens`, { signal });

    return data?.itens;
  }
}

export default new FluxoService();
